import Splide from '@splidejs/splide';
import { splideA11yOptions, fixSplideSlideRoles } from '@resources/js/splide-a11y';

document.addEventListener('DOMContentLoaded', function() {
    const splideSelector = '.news-slider.splide';
    if (document.querySelector(splideSelector)) {
        const splide = new Splide(splideSelector, {
            type      : 'loop',
            perPage   : 3,
            perMove   : 1,
            gap       : '1rem',
            pagination: false,
            focus     : 'center',
            arrows    : true,
            start     : 1,
            autoplay  : false,
            interval  : 8000,
            breakpoints: {
                768: {
                    perPage: 1,
                },
                1024: {
                    perPage: 2,
                }
            },
            ...splideA11yOptions('Related news carousel'),
        });

        fixSplideSlideRoles(splide);
        splide.mount();
    }
});